import { IDisplayContract } from '../Contract/Contract-types';
import { IPropertySuggestion } from '../IssuePane/IssuePaneTabs/IssuePaneSuggestionTab/ParagraphSuggestions/ParagraphSuggestion/ParagraphSuggestion-types';
import { IContractReportRow } from '../IssuesReport/HybridReportDataGrid/HybridReportDataGrid-types';
import { IFeatureToggle } from '../FeatureToggleProvider/FeatureToggleProvider-types';
import { ContractIssue } from '@thought-river/negotiations-common';

export const PAGE_SIZE = 10;
export const LOAD_MORE_SUGGESTIONS_DISTANCE = 32;

export interface ISuggestionsSidebarState {
    editedSuggestionId: string;
    loading: boolean;
    suggestions: IPropertySuggestion[];
    suggestionCount: number;
    pageNumber: number;
}

export interface ISuggestionsSidebarStateProps {
    contract: IDisplayContract;
    issues: ContractIssue[];
    featureToggles: IFeatureToggle[];
}

export interface ISuggestionsSidebarReducer {}

export interface ISuggestionsSidebarDispatchProps {}

export interface ISuggestionsSidebarProps
    extends ISuggestionsSidebarDispatchProps,
        ISuggestionsSidebarStateProps {
    lazyLoad?: boolean;
    onCloseCallback: () => void;
    onSuggestionSelectedCallback: (suggestion: IPropertySuggestion) => void;
    row: IContractReportRow | ContractIssue | null;
    show: boolean;
    width: number;
}

export type ISuggestionsSidebarActionTypes = any;
